import React from "react"
import autobind from "class-autobind"
import { Tabs, Tab } from "material-ui/Tabs"
import strings from "../../localization/strings"
import CustomFieldLabels from "./CustomFieldLabels"
import CustomPositionFieldLabel from "./CustomPositionFieldLabel"
import AccountStore from "../../stores/AccountStore"
interface IProps {}
interface IState {
    tabActive: string
}

export default class CustomFieldSettings extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            tabActive: "custom_job_field_labels"
        }
        autobind(this)
    }

    render() {
        return (
            <div style={{ margin: -16 }}>
                <Tabs value={this.state.tabActive} onChange={(tabActive) => this.setState({ tabActive })}>
                    <Tab value="custom_job_field_labels" label={strings.Job_Field}>
                        {this.state.tabActive === "custom_job_field_labels" && (
                            <div>
                                <CustomFieldLabels type="JobCustomLabels" />
                                <CustomPositionFieldLabel
                                    fieldType={"JobFieldLabels"}
                                    pluralField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.PluralJobLabel}
                                    singularField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.JobFieldLabels.SingularJobLabel}
                                    singularKey="SingularJobLabel"
                                    pluralKey="PluralJobLabel"
                                    pluralLabel={strings.Plural_Job_Label}
                                    singularLabel={strings.Singular_Job_Label}
                                />
                            </div>
                        )}
                    </Tab>
                    <Tab value="custom_employee_field_labels" label={strings.Employee_Field}>
                        {this.state.tabActive === "custom_employee_field_labels" && <CustomFieldLabels type="EmployeeCustomLabels" />}
                    </Tab>
                    <Tab value="custom_client_field_labels" label={strings.Client_Field}>
                        {this.state.tabActive === "custom_client_field_labels" && <CustomFieldLabels type="ClientCustomLabels" />}
                    </Tab>
                    <Tab value="custom_device_field_labels" label={strings.Device_Field}>
                        {this.state.tabActive === "custom_device_field_labels" && <CustomFieldLabels type="DeviceCustomLabels" />}
                    </Tab>
                    <Tab value="custom_positions_field_labels" label={strings.Positions_Field}>
                        {this.state.tabActive === "custom_positions_field_labels" && (
                            <CustomPositionFieldLabel
                                fieldType={"PositionFieldLabels"}
                                pluralField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.PluralPositionLabel}
                                singularField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.PositionFieldLabels.SingularPositionLabel}
                                singularKey="SingularPositionLabel"
                                pluralKey="PluralPositionLabel"
                                pluralLabel={strings.Plural_Position_Label}
                                singularLabel={strings.Singular_Position_Label}
                            />
                        )}
                    </Tab>
                    <Tab value="custom_phase_field_labels" label={strings.Phase_Field}>
                        {this.state.tabActive === "custom_phase_field_labels" && (
                            <CustomPositionFieldLabel
                                fieldType={"PhaseFieldLabels"}
                                pluralField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.PluralPhaseLabel}
                                singularField={AccountStore.getCurrentAccountSettings().CustomFieldSettings.PhaseFieldLabels.SingularPhaseLabel}
                                singularKey="SingularPhaseLabel"
                                pluralKey="PluralPhaseLabel"
                                pluralLabel={strings.Plural_Phase_Label}
                                singularLabel={strings.Singular_Phase_Label}
                            />
                        )}
                    </Tab>
                </Tabs>
            </div>
        )
    }
}
